export default "__VITE_ASSET__NSd20HN6__"